module.exports = __webpack_public_path__ + "img/luv-logo-wide.808b9776.png";